export const name = "UPPER";
export const summary = `Formats alphabetic characters in a \`STRING\` value as uppercase.        Formats ASCII characters in a \`BYTES\` value as uppercase.`;
export const reference = `
## UPPER

Formats alphabetic characters in a \`STRING\` value as uppercase.   
  
 Formats ASCII characters in a \`BYTES\` value as uppercase.

\`\`\`
UPPER(value)
\`\`\`

### Description

For \`STRING\` arguments, returns the original string with all alphabetic characters in uppercase. Mapping between uppercase and lowercase is done according to the Unicode Character Databasewithout taking into account language-specific mappings.

For \`BYTES\` arguments, the argument is treated as ASCII text, with all bytes greater than 127 left intact.


### Return type

\`STRING\` or \`BYTES\`


### Examples



\`\`\`
SELECT UPPER('foo') AS example

/*---------*
 | example |
 +---------+
 | FOO |
 *---------*/
\`\`\`




source: https://cloud.google.com/bigquery/docs/reference/standard-sql/string_functions
`;
